(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('AvmReportViewController', AvmReportViewController);

    AvmReportViewController.$inject = ['$stateParams', '$sce', 'report'];

    /**
     * Public, signed-out view of a delivered AVM report.
     *
     * There is deliberately no HTML/web-report path here. A Gnowise AVM is delivered as a finished PDF
     * with no dynamic form, so generate-html would return an empty document; the PDF is the report.
     */
    function AvmReportViewController($stateParams, $sce, report) {
        var vm = this;

        vm.appraisalReport = report;
        vm.heading = 'Automated Valuation Report';

        // The by-access-key variant is permitAll, so it serves without a session - which is the whole
        // point of the link this page is opened from.
        vm.appraisalReportPdfUrl = $sce.trustAsResourceUrl(
            '/api/appraisal-reports/generate-pdf/by-access-key/' + $stateParams.accessKey);
    }
})();
